import React, { useState, useEffect, useRef } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import wallbox from '../images/wallbox/banner.webp';
import wallboxBg from '../images/wallbox/pic1.webp';
import wallboxFull from '../images/wallbox/pic10.jpg';
import wallboxVideo from '../images/wallbox/v100.mp4';
import wallboxVideo1 from '../images/wallbox/v1.mp4';
import wallboxVideo2 from '../images/wallbox/v2.mp4';
import wallboxVideo3 from '../images/wallbox/v3.mp4';
import wallboxVideo4 from '../images/wallbox/v4.mp4';
import pdfPic1 from '../images/wallbox/pdfpic1.png';
import pdfPic2 from '../images/wallbox/pdfpic2.png';
import { useSEO } from '../components/CustomHook';
import Modal from '../components/Modal';

const Wallbox = () => {
    useSEO(
        "Wallbox - Elektroauto Ladestation für Zuhause | Schmid Energieberatung",
        "Entdecken Sie unsere sicheren und effizienten Wallbox-Lösungen für Ihr Elektrofahrzeug. Schnelle Ladung mit modernster Technologie und benutzerfreundlichen Funktionen.",
        "Wallbox, Elektroauto Ladestation, E-Auto laden, Wallbox kaufen, Ladestation Zuhause, Elektroauto Ladebox",
        "/images/products/wallbox.webp"
    );

    // Add state for modal
    const [modalData, setModalData] = useState({ isOpen: false, title: '', content: [] });
    const [count, setCount] = useState(0);
    const [hasCounted, setHasCounted] = useState(false);
    const box1Ref = useRef(null);

    // Function to close modal
    const closeModal = () => {
        setModalData({ isOpen: false, title: '', content: [] });
    };

    // Function to open modal with specific content
    const openBox1Modal = () => {
        setModalData({
            isOpen: true,
            title: 'Sigen EV AC-Ladegerät – Schnell. Einfach. Alltagstauglich.',
            content: [
                <>
                Mit <strong>bis zu 22 kW Ladeleistung</strong> lädt das <strong>Sigen EV AC-Ladegerät</strong> Ihr E-Auto
                <strong>doppelt so schnell</strong> wie viele marktübliche Wallboxen.
                Ein Fahrzeug mit 40 kWh Akku ist in ca. <strong>zwei Stunden voll geladen</strong> – statt vier.
                </>,
                "Ideal für alle, die mobil bleiben müssen und keine Zeit verlieren wollen. Leistungsstark, effizient und einfach zu bedienen – perfekt für Ihr Zuhause."
            ]
        });
    };

    const openBox2Modal = () => {
        setModalData({
            isOpen: true,
            title: 'Sigen EV DC – Die nächste Stufe der Heimenergieintegration',
            content: [
                <>
                Mit dem <strong>Sigen EV DC Charging Module</strong> beginnt eine neue Ära der Energieunabhängigkeit.
                Als <strong>weltweit erstes All-in-One-Heimenergiesystem mit integrierter V2X-Technologie</strong>
                verbindet es Elektromobilität und Energiespeicherung auf völlig neue Weise – <strong>bidirektional,
                effizient und nachhaltig</strong>.
                </>,
                <>
                Mit bis zu <strong>25 kW Lade- und Entladeleistung</strong>, einer variablen <strong>Ladespannung von 150–
                1000 V</strong>und <strong>universeller EV-Kompatibilität</strong> ermöglicht Sigen EV DC nicht nur das
                ultraschnelle Laden Ihres Fahrzeugs, sondern auch die <strong>Rückeinspeisung von Strom aus der
                Fahrzeugbatterie ins Hausnetz (V2H)</strong> – oder sogar ins öffentliche Netz (V2G). Damit wird
                Ihr Elektrofahrzeug zur mobilen Energieressource.
                </>,
                <>
                Ob zur <strong>Sicherung der Stromversorgung bei Netzausfall</strong>, zur <strong>Entlastung durch Peak
                Shaving</strong>, oder für den <strong>Einsatz in virtuellen Kraftwerken (VPP)</strong> – dieses Modul eröffnet
                <strong>völlig neue Dimensionen in der Energievernetzung</strong>.
                </>,
                <>
                Dank <strong>IP66-Schutzklasse</strong>, wartungsfreiem Betrieb und vollständiger Integration in das Sigen-
                Energiesystem ist der EV DC Charger nicht nur leistungsstark, sondern auch zuverlässig und
                zukunftssicher.
                </>,
            ]
        });
    };

    const openBox3Modal = () => {
        setModalData({
            isOpen: true,
            title: 'Nutzen Sie Ihren PV-Überschuss intelligent – für Auto, Wärme und Komfort',
            content: [
                <>
                Mit dem <strong>PV-Überschussladen</strong> können Sie überschüssige Solarenergie gezielt einsetzen,
                anstatt sie ins Netz einzuspeisen. Ob zum <strong>Laden Ihres Elektrofahrzeugs</strong>, zur
                <strong>Unterstützung Ihrer Heizstäbe</strong> oder zum <strong>Betrieb einer Klimaanlage</strong> – Sie bestimmen,
                wofür Ihre Sonnenenergie genutzt wird.
                </>,
                <>
                So erhöhen Sie Ihren Eigenverbrauch, senken Ihre Energiekosten und machen sich
                unabhängiger vom Netzstrom. Gleichzeitig leisten Sie einen aktiven Beitrag zum Klimaschutz
                – denn jede Kilowattstunde, die Sie selbst nutzen, ist sauber, lokal und nachhaltig.
                </>,
                <>
                <strong>Intelligent. Effizient. Zukunftssicher – mit PV-Überschussladen.</strong>
                </>,
            ]
        });
    };

    const openBox4Modal = () => {
        setModalData({
            isOpen: true,
            title: 'Intelligent vernetzt',
            content: [
                <>
                Mit der <strong>mySigen App</strong> steuern Sie Ihre Wallbox bequem per Smartphone.
                Behalten Sie in Echtzeit die Ladeleistung im Blick und aktivieren Sie das <strong>PV-
                Überschussladen</strong>, um Ihr Fahrzeug mit selbst erzeugter Sonnenenergie zu laden.
                </>,
                <>
                Für volle Flexibilität steht Ihnen zusätzlich die <strong>Ad-hoc-Ladefunktion </strong>zur Verfügung – ideal,
                wenn Sie bei Bedarf schnell mit Netzstrom laden möchten.
                <strong>Effizient, nachhaltig und ganz einfach steuerbar – mit SigenAi</strong>
                </>,
            ]
        });
    };

    // Animation for the count in Box 1
    useEffect(() => {
        let start = 0;
        const end = 22;

        if (hasCounted) {
            const duration = 2000; // 2 seconds
            const increment = end / (duration / 16); // 16ms per frame
            const timer = setInterval(() => {
                start += increment;
                if (start >= end) {
                    setCount(end);
                    clearInterval(timer);
                } else {
                    setCount(Math.ceil(start));
                }
            }, 16);
            return () => clearInterval(timer);
        }
    }, [hasCounted]);

    // Intersection Observer to trigger count when Box 1 is in view
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !hasCounted) {
                    setHasCounted(true);
                }
            },
            {
                threshold: 1.0 // Trigger only when 100% of the element is visible
            }
        );

        const node = box1Ref.current;
        if (node) {
            observer.observe(node);
        }

        return () => {
            if (node) {
                observer.unobserve(node);
            }
        };
    }, [hasCounted]);

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={wallbox}
                title="Wallbox"
                subtitle="Sichere und schnelle Ladung für Ihr Elektrofahrzeug"
                description="Unsere Wallbox-Lösungen bieten Ihnen eine sichere und effiziente Möglichkeit, Ihr Elektrofahrzeug zu Hause zu laden. Mit modernster Technologie und benutzerfreundlichen Funktionen."
            />

            <div className="container mx-auto px-4 py-8">
                <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
                    Modern laden, nachhaltig fahren – Energie, die bewegt.
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                    {/* Box 1 */}
                    <div
                        ref={box1Ref}
                        className="border rounded-lg p-12 flex flex-col items-center text-center cursor-pointer"
                        onClick={openBox1Modal}
                    >
                        <h3 className="text-2xl font-bold mb-6">Ladeleistung bis zu 22 kW</h3>
                        <p className="mb-6 text-3xl font-bold text-primary">{count} kW Ladepower – Schnell. Smart. Sauber.</p>
                        <button
                            className="bg-primary text-white rounded-lg font-semibold text-base px-6 py-3 transition-all duration-200 hover:scale-105"
                            onClick={(e) => {
                                e.stopPropagation();
                                openBox1Modal();
                            }}
                        >
                            mehr erfahren
                        </button>
                    </div>

                    {/* Box 2 */}
                    <div
                        className="border rounded-lg p-12 flex flex-col items-center text-center cursor-pointer relative overflow-hidden"
                        onClick={() => {
                            // Scroll to the bottom of the page
                            window.scrollTo({
                                top: document.body.scrollHeight,
                                behavior: 'smooth'
                            });
                        }}
                        style={{
                            backgroundImage: `url(${wallboxBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    >
                        <div className="absolute inset-0"></div>
                        <div className="relative z-10 flex items-center justify-center h-full">
                            <h3
                                className="text-2xl font-bold text-white text-center"
                                style={{
                                    textShadow: '2px 2px 16px rgba(0, 0, 0, 1)'
                                }}
                            >
                                Von der Sonne geladen. Für den Alltag gemacht.
                            </h3>
                        </div>
                    </div>

                    {/* Box 3 - spans across both columns */}
                    <div className="md:col-span-2 border rounded-lg p-12 flex flex-col items-center text-center cursor-pointer"
                         onClick={openBox2Modal}>
                        <h3 className="text-2xl font-bold mb-6">Sigen EV DC – Die nächste Stufe der Heimenergieintegration</h3>
                        <p className="mb-6 text-lg">
                            Unsere fortschrittliche Technologie ermöglicht den direkten Zugriff auf Gleichstrom aus
                            Batterie und Solarmodul und ermöglicht so die Erweiterung der virtuellen Netzkapazität
                            sowie das Laden mit 100 % Ökostrom. Machen Sie sich bereit für die Zukunft mit V2H-
                            (Vehicle-to-Home) und V2G-Funktionen (Vehicle-to-Grid) und eröffnen Sie sich
                            grenzenlose Möglichkeiten für ein modernes Leben.
                        </p>
                        <button
                            className="bg-primary text-white rounded-lg font-semibold text-base px-6 py-3 transition-all duration-200 hover:scale-105"
                            onClick={(e) => {
                                e.stopPropagation();
                                openBox2Modal();
                            }}
                        >
                            mehr erfahren
                        </button>
                    </div>
                </div>
            </div>

            {/* Full width image below boxes */}
            <div className="w-full">
                <img
                    src={wallboxFull}
                    alt="Wallbox"
                    className="w-full h-auto"
                />
            </div>

            {/* Text content below image */}
            <div className="container mx-auto px-4 py-8">
                <h2 className="text-center text-2xl font-bold mb-8 text-primary">
                    Ihr Ladechampion für Zuhause – leistungsstark, flexibel,<br />
                    intelligent
                </h2>
                <p className="text-center text-lg mb-8">
                    Das Sigen EV AC-Ladegerät definiert Heimladen neu: Mit starker Ladeleistung und smarter<br />
                    Steuerung sorgt es für ein schnelles, effizientes und komfortables Aufladen Ihres Elektrofahrzeugs.<br />
                    Dank intelligenter Funktionen behalten Sie jederzeit die volle Kontrolle – für maximale Flexibilität<br />
                    und optimale Energieausnutzung direkt bei Ihnen zu Hause.
                </p>

                {/* Two boxes side by side */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                    {/* Box 1 */}
                    <div
                        className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                        onClick={openBox3Modal}
                    >
                        <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Nutzen Sie Ihren PV-Überschuss<br />intelligent – für Auto, Wärme und<br />Komfort</h3>
                        <div className="mt-6 text-center">
                            <button
                                className="bg-primary text-white rounded-lg font-semibold text-base px-6 py-3 transition-all duration-200 hover:scale-105"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openBox3Modal();
                                }}
                            >
                                mehr erfahren
                            </button>
                        </div>
                    </div>

                    {/* Box 2 */}
                    <div
                        className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                        onClick={openBox4Modal}
                    >
                        <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Intelligent vernetzt<br />Hier wieder Sigen Handy als<br />Hintergrund</h3>
                        <div className="mt-6 text-center">
                            <button
                                className="bg-primary text-white rounded-lg font-semibold text-base px-6 py-3 transition-all duration-200 hover:scale-105"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openBox4Modal();
                                }}
                            >
                                mehr erfahren
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Video section */}
            <div className="container mx-auto px-4 py-8">
                <video
                    className="w-full h-auto rounded-xl overflow-hidden"
                    autoPlay
                    loop
                    muted
                    playsInline
                >
                    <source src={wallboxVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            {/* Autoplay videos grid */}
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="overflow-hidden rounded-xl">
                        <video
                            className="w-full h-full object-cover"
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src={wallboxVideo1} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="overflow-hidden rounded-xl -translate-y-4">
                        <video
                            className="w-full h-full object-cover"
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src={wallboxVideo2} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="overflow-hidden rounded-xl">
                        <video
                            className="w-full h-full object-cover"
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src={wallboxVideo3} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="overflow-hidden rounded-xl -translate-y-4">
                        <video
                            className="w-full h-full object-cover"
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src={wallboxVideo4} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>

            {/* Modal for details */}
            <Modal isOpen={modalData.isOpen} onClose={closeModal} title={modalData.title} content={modalData.content} />

            {/* PDF Download Section */}
            <div className="bg-gray-800 py-12">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-2xl font-bold text-white mb-8">Produktinformationen & Downloads</h2>
                    <div className="flex flex-col md:flex-row justify-center gap-6">
                        {/* First PDF Download */}
                        <div className="flex flex-col items-center">
                            <img
                                src={pdfPic1}
                                alt="Sigen EV AC Ladegerät"
                                className="mb-4 w-full max-w-xs h-auto"
                                onLoad={() => console.log('pdfPic1 loaded successfully')}
                                onError={(e) => {
                                    console.log('Error loading pdfPic1:', e);
                                    e.target.src = '/images/wallbox/pdfpic1.png'; // Fallback
                                }}
                            />
                            <a
                                href="/pdf/wallbox/Energielösung%20für%20Zuhause%20-%20Sigen%20EV%20AC%20Charger%20.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                            >
                                Produktinformation Sigen EV AC Ladegerät
                            </a>
                        </div>

                        {/* Second PDF Download */}
                        <div className="flex flex-col items-center">
                            <img
                                src={pdfPic2}
                                alt="Sigen EV DC Charging Modul"
                                className="mb-4 w-full max-w-xs h-auto"
                                onLoad={() => console.log('pdfPic2 loaded successfully')}
                                onError={(e) => {
                                    console.log('Error loading pdfPic2:', e);
                                    e.target.src = '/images/wallbox/pdfpic2.png';
                                }}
                            />
                            <a
                                href="/pdf/wallbox/Energielösung%20für%20Zuhause%20-%20Sigen%20EV%20DC%20Charging%20Modul.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                            >
                                Technische Daten Sigen EV DC Charging Modul
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Wallbox;